import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';

import { Link } from 'dibs-elements/exports/Link';
// styles
import styles from './SearchBarTerm.scss';

export const SearchBarTermComponent = props => {
    const {
        href,
        term,
        handleRowClick,
        cursorHighlightId,
        id,
        termElements,
        isNavigationRefreshVariant,
    } = props;
    const searchBarTermClasses = classnames(styles.item, {
        [styles.active]: id === cursorHighlightId,
    });

    const linkClasses = classnames(styles.link, {
        [styles.navigationRefreshLink]: isNavigationRefreshVariant,
    });

    return (
        <div className={searchBarTermClasses}>
            <Link
                dataTn="search-bar-term"
                className={linkClasses}
                href={href}
                onClick={e => {
                    e.preventDefault();
                    handleRowClick(term, href, e);
                }}
            >
                {termElements}
            </Link>
        </div>
    );
};

SearchBarTermComponent.propTypes = {
    term: PropTypes.string,
    termElements: PropTypes.any,
    href: PropTypes.string,
    handleRowClick: PropTypes.func,
    cursorHighlightId: PropTypes.string,
    id: PropTypes.string,
    isNavigationRefreshVariant: PropTypes.bool,
};

const mapStateToProps = ({ header }) => {
    const { isNavigationRefreshVariant } = header;
    return {
        isNavigationRefreshVariant,
    };
};
export const SearchBarTerm = connect(mapStateToProps)(SearchBarTermComponent);
